<template>
<div class="chapter">
<div class="inner_page">
<p class="copy2">First published in Great Britain in 2017 by</p>
<p class="copy">Pen &amp; Sword Transport</p>
<p class="copy">An imprint of Pen &amp; Sword Books Ltd</p>
<p class="copy">47 Church Street</p>
<p class="copy">Barnsley</p>
<p class="copy">South Yorkshire</p>
<p class="copy">S70 2AS</p>
<p class="copy1">Copyright © Kevin R. McCormack 2017</p>
<p class="copy1">ISBN 9781473871984</p>
<p class="copy">eISBN 9781473872004</p>
<p class="copy">Mobi ISBN 9781473871991</p>
<p class="copy1">The right of Kevin R. McCormack to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988. All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording or any information storage and retrieval system, without the prior written permission of the publisher, nor by way of trade or otherwise shall it be lent, re-sold, hired out or otherwise circulated without the publisher’s prior consent in any form of binding or cover other than that in which it is published and without a similar condition including this condition being imposed on the subsequent purchaser.</p>
<p class="copy">© Kevin R. McCormack 2017</p>
<p class="copy1">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Social History, Transport, True Crime, and Claymore Press, Frontline Books, Leo Cooper, Praetorian Press, Remember When, Seaforth Publishing and Wharncliffe.</p>
<p class="copy1">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy">Pen &amp; Sword Books Limited</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy">E-mail: <span class="weblink"><a href="http://enquiries@pen-and-sword.co.uk" target="_blank"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Copyright.vue?8f0ee6a4